module.exports = __webpack_public_path__ + "img/coppay.3369b895.png";